// import {store1} from '../store/index's

var DataStore = require('../store');
var store = DataStore.default

const fetchPOST = () => {
  return store.state.kamio
}

const getKab = (wilayah) => {
  fetch(store.state.url.URL_planning_kabupaten + "list", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      wilayah: wilayah
    })
  })
    .then(res => res.json())
    .then(res_data => {
      // console.log(res_data)
      store.state.listKabKota = res_data
    });
}

const getKec = (kab_kota) => {
  fetch(store.state.url.URL_planning_kecamatan + "list", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      kab_kota: kab_kota
    })
  })
    .then(res => res.json())
    .then(res_data => {
      // console.log(res_data)
      store.state.listKec = res_data
    });
}

const getKecSingle = () => {
  fetch(store.state.url.URL_planning_kecamatan + "listSingle", {
    method: "GET",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    }
  })
    .then(res => res.json())
    .then(res_data => {
      // console.log(res_data)
      store.state.listKec = res_data
    });
}

const getDesKel = (kecamatan) => {
  // console.log(kecamatan)
  fetch(store.state.url.URL_DATAMASTER_DES_KEL + "list", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      kecamatan: kecamatan
    })
  })
    .then(res => res.json())
    .then(res_data => {
      // console.log(res_data)
      store.state.listDesKel = res_data
    });
}


const getInstansi = (kabupaten_id) => {
    // console.log(kecamatan)
    fetch(store.state.url.URL_simpeg_instansi + "list", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body: JSON.stringify({
        kabupaten_id: 'kabupaten_id'
      })
    })
        .then(res => res.json())
        .then(res_data => {
        // console.log(res_data)
        store.state.list_instansi = res_data
    });
}


const getUnitKerja = (instansi) => {
    // console.log(kecamatan)
    fetch(store.state.url.URL_simpeg_unit_kerja + "list", {
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body: JSON.stringify({
        instansi: instansi
      })
    })
        .then(res => res.json())
        .then(res_data => {
        store.state.list_unit_kerja = res_data
        // console.log(res_data)
    });
}

const getBiodata = (sub_unit_kerja) => {
  // console.log(kecamatan)
  fetch(store.state.url.URL_simpeg_biodata + "list", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      unit_kerja: sub_unit_kerja
    })
  })
      .then(res => res.json())
      .then(res_data => {
      store.state.list_biodata = res_data
      // console.log(res_data)
  });
}



const getMetodeAbsen = (sub_unit_kerja) => {
  // console.log(kecamatan)
  fetch(store.state.url.URL_simpeg_biodata + "list_metode_absen", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      unit_kerja: ''
    })
  })
      .then(res => res.json())
      .then(res_data => {
      store.state.list_metode_absen = res_data
      // console.log(res_data)
  });
}



const getJenisJabatan = (unit_kerja) => {
  fetch(store.state.url.URL_simpeg_jenis_jabatan + "list", {
      method : 'GET',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      }
  }).then((res) => res.json()).then((datanya) => {
     store.state.list_jenis_jabatan = datanya;
  })
}

const getKelasJabatan = () => {
  fetch(store.state.url.URL_simpeg_kelas_jabatan + "list", {
      method : 'GET',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      }
  }).then((res) => res.json()).then((datanya) => {
     store.state.list_kelas_jabatan = datanya;
  })
}

const getJabatan = (unit_kerja) => {
    fetch(store.state.url.URL_simpeg_jabatan + "listJabatan", {
        method : 'POST',
        headers : {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body : JSON.stringify({
          unit_kerja : unit_kerja

        })
    }).then((res) => res.json()).then((datanya) => {
      // console.log(datanya);
       store.state.list_jabatan = datanya;
    })
}

const getAtasanJabatan = (unit_kerja) => {
  fetch(store.state.url.URL_simpeg_jabatan, {
    method : 'POST',
    headers : {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body : JSON.stringify({
      unit_kerja : unit_kerja

    })
}).then((res) => res.json()).then((datanya) => {
  store.state.list_jabatan = datanya;
  // console.log(datanya);
})
}


const getGolongan = () => {
  fetch(store.state.url.URL_simpeg_golongan + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        unit_kerja : 'unit_kerja'

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.golonganSelect = res_data
    // console.log(res_data)
  })
}


const getJenisKel = () => {
  fetch(store.state.url.URL_simpeg_simpeg_jenisKelamin + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        unit_kerja : 'unit_kerja'

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_jenis_kelamin = res_data
    // console.log(res_data)
  })
}


const getPendidikanAkhir = () => {
  fetch(store.state.url.URL_simpeg_strata_ijazah + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        unit_kerja : 'unit_kerja'
      })
    }).then((res) => res.json()).then((res_data) => {
      store.state.list_strata_ijazah = res_data
      // console.log(res_data)
    })
  }

const getJK = () => {
  fetch(store.state.url.URL_simpeg_simpeg_jenisKelamin + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        unit_kerja : 'unit_kerja'

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_jenis_kelamin = res_data
    // console.log(res_data)
  })
}


const getStatusKeluarga = () => {
  fetch(store.state.url.URL_simpeg_simpeg_statusKeluarga + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        unit_kerja : 'unit_kerja'

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_status_keluarga = res_data
    // console.log(res_data)
  })
}

const getAgama = () => {
  fetch(store.state.url.URL_simpeg_agama + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        unit_kerja : 'unit_kerja'

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_agama = res_data
    // console.log(res_data)
  })
}

const getStrataIjazah = () => {
  fetch(store.state.url.URL_simpeg_strata_ijazah + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        unit_kerja : 'unit_kerja'

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_strata_ijazah = res_data
    // console.log(res_data)
  })
}

const getEsselon = () => {
  fetch(store.state.url.URL_simpeg_esselon + "list", {
      method : 'POST',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body : JSON.stringify({
        unit_kerja : 'unit_kerja'

      })
  }).then((res) => res.json()).then((res_data) => {
    store.state.esselonSelect = res_data
    // console.log(res_data)
  })
}

const getLatStruktural = () => {
  fetch(store.state.url.URL_simpeg_diklat_struktural + "getLatStruktural", {
      method : 'GET',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      }
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_jns_latihan_struktural = res_data
    console.log(res_data)
  })
}
const getJnsDiklat = () => {
  fetch(store.state.url.URL_simpeg_diklat_struktural + "getJnsDiklat", {
      method : 'GET',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      }
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_jns_diklat = res_data
    // console.log(res_data)
  })
}
const getJnsKompetensi = () => {
  fetch(store.state.url.URL_simpeg_diklat_struktural + "getJnsKompetensi", {
      method : 'GET',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      }
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_jns_kompetensi = res_data
    // console.log(res_data)
  })
}
const getJnsHukuman = () => {
  fetch(store.state.url.URL_simpeg_riwayat_hukdis + "getJnsHukuman", {
      method : 'GET',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      }
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_jns_hukuman = res_data
    console.log(res_data)
  })
}
const getAlasanHukuman = () => {
  fetch(store.state.url.URL_simpeg_riwayat_hukdis + "getAlasanHukuman", {
      method : 'GET',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      }
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_alasan_hukuman = res_data
    // console.log(res_data)
  })
}
const getJnsKedudukanHukum = () => {
  fetch(store.state.url.URL_simpeg_riwayat_hukdis + "getJnsKedudukanHukum", {
      method : 'GET',
      headers : {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      }
  }).then((res) => res.json()).then((res_data) => {
    store.state.list_jns_kedudukan_hukum = res_data
    // console.log(res_data)
  })
}


const getProfileSIA_ASN = (nip) => {

  return new Promise((resolve, reject) => {
    fetch(store.state.url.URL_simpeg_biodata + "si_asn_viewOne", {
      method: "POST",
      headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
      },
      body: JSON.stringify({
          nip: nip,
      })
      })
      .then(res => res.json())
      .then(res_data => {

        // console.log(res_data.data);
        resolve(res_data.data)
    });
    
  })
}


// ============================================== SIASN ==============================================

const getInstansi_SIASN = (value) => {

  fetch(store.state.url.URL_simpeg_instansi + "autocomplete_instansi_siasn", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      val: value
    })
  })
      .then(res => res.json())
      .then(res_data => {
      store.state.list_instansi_siasn = res_data
      // console.log(res_data)
  });
}


const getSatker_SIASN = (value) => {

  fetch(store.state.url.URL_simpeg_instansi + "autocomplete_satker_siasn", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      val: value
    })
  })
      .then(res => res.json())
      .then(res_data => {
      store.state.list_satker_siasn = res_data
      // console.log(res_data)
  });
}

const getRefJabatan_SIASN = (value, kelas_id) => {

  fetch(store.state.url.URL_simpeg_jabatan + "autocomplete_jabatan_referensi_siasn", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      val: value,
      kelas_id :kelas_id
    })
  })
      .then(res => res.json())
      .then(res_data => {
      store.state.list_refJabatan_siasn = res_data
      // console.log(res_data)
  });
}
const getUnor_SIASN = (value) => {

  fetch(store.state.url.URL_simpeg_instansi + "autocomplete_unor_siasn", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      val: value
    })
  })
      .then(res => res.json())
      .then(res_data => {
      store.state.list_unor_siasn = res_data
      // console.log(res_data)
  });
}



const getJabatanFungsional_SIASN = (value) => {

  fetch(store.state.url.URL_simpeg_jabatan + "autocomplete_jabatan_fungsional_siasn", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      val: value
    })
  })
      .then(res => res.json())
      .then(res_data => {
      store.state.list_jabatan_fungsional_siasn = res_data
      // console.log(res_data)
  });
}

const getJabatanFungsionalUmum_SIASN = (value) => {

  fetch(store.state.url.URL_simpeg_jabatan + "autocomplete_jabatan_fungsional_umum_siasn", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      val: value
    })
  })
      .then(res => res.json())
      .then(res_data => {
      store.state.list_jabatan_fungsional_umum_siasn = res_data
      // console.log(res_data)
  });
}







// ============================================== SIASN ==============================================




module.exports = {
  fetchPOST: fetchPOST,
  getKab : getKab,
  getKec : getKec,
  getKecSingle : getKecSingle,
  getDesKel : getDesKel,
  getInstansi : getInstansi,
  getUnitKerja : getUnitKerja,
  getBiodata : getBiodata,
  getJabatan : getJabatan,
  getJenisJabatan :getJenisJabatan,
  getKelasJabatan : getKelasJabatan,
  getAtasanJabatan : getAtasanJabatan,
  getGolongan : getGolongan,
  getJK : getJK,
  getStatusKeluarga : getStatusKeluarga,
  getAgama : getAgama,
  getStrataIjazah : getStrataIjazah,
  getJenisKel : getJenisKel,
  getPendidikanAkhir : getPendidikanAkhir,
  getEsselon : getEsselon,
  getLatStruktural : getLatStruktural,
  getMetodeAbsen : getMetodeAbsen,


  getProfileSIA_ASN : getProfileSIA_ASN,
  getInstansi_SIASN : getInstansi_SIASN,
  getSatker_SIASN : getSatker_SIASN,
  getJabatanFungsional_SIASN : getJabatanFungsional_SIASN,
  getJabatanFungsionalUmum_SIASN : getJabatanFungsionalUmum_SIASN,
  getUnor_SIASN : getUnor_SIASN,
  getRefJabatan_SIASN : getRefJabatan_SIASN,

  getJnsDiklat : getJnsDiklat,
  getJnsKompetensi : getJnsKompetensi,
  getJnsHukuman : getJnsHukuman,
  getAlasanHukuman : getAlasanHukuman,
  getJnsKedudukanHukum : getJnsKedudukanHukum,



}